var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2022 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Container, Row, Col } from "../index";
import { SangerLogo } from "./Icons";
function Footer() {
    return (_jsx("footer", __assign({ className: "footer" }, { children: _jsx(Container, { children: _jsxs(Row, __assign({ sm: 1, md: 2 }, { children: [_jsx(Col, __assign({ sm: 6, md: 4, lg: 3 }, { children: _jsx("div", __assign({ className: "centre" }, { children: _jsx("a", __assign({ href: "https://sanger.ac.uk" }, { children: _jsx(SangerLogo, {}) })) })) })), _jsx(Col, __assign({ sm: 6, md: { span: 4, offset: 4 }, lg: { span: 3, offset: 6 } }, { children: _jsx("div", __assign({ className: "centre" }, { children: _jsxs("p", __assign({ className: "footer-text" }, { children: [_jsx("a", __assign({ href: "https://www.sanger.ac.uk/programme/tree-of-life/" }, { children: "Tree of Life Programme" })), _jsx("br", {}), _jsx("a", __assign({ href: "https://www.sanger.ac.uk/group/tree-of-life-enabling-platforms/" }, { children: "Enabling Platforms" }))] })) })) }))] })) }) })));
}
export default Footer;
